import Tooltip from '../../tnew/ui/Tooltip';
import IconSprites from '../../utils/IconSprites';
import { srOnlyElement } from '../../utils/screen-reader/html';
import SvgIcon from '../../utils/SvgIcon';
import SyosPageComponent from '../components/SyosPageComponent';
import { parseElementHtml } from './html';

function build(rootHeadingLevel: number): {
  el: HTMLDivElement;
  btnZoomInEl: HTMLButtonElement;
  btnZoomOutEl: HTMLButtonElement;
  btnResetEl: HTMLButtonElement;
} {
  const HEADING_ID: string = 'tn-syos-map-controls-list-heading';

  const { mapControlsLabel } = SyosPageComponent;

  const headingTag = `h${rootHeadingLevel + 1}`;

  const $el = parseElementHtml(`
  <div class="tn-syos-map-controls-list">
  ${srOnlyElement(headingTag, mapControlsLabel, { id: HEADING_ID })}
  <ul class="tn-syos-zoom-control" aria-labelledby="${HEADING_ID}">
    <li class="tn-syos-map-controls-list__list-item tn-syos-map-controls-list__list-item--zoom-out">
      <div id="tn-tooltip-container-zoom-out" class="tn-tooltip__container">
        <button type="button" class="btn btn-default tn-syos-zoom-control__btn tn-syos-zoom-control__btn-zoom tn-syos-zoom-control__btn-zoom--zoom-out">
          ${SvgIcon.getHtml(IconSprites.Dash, 'tn-syos-zoom-control__icon-btn-zoom')}
        </button>
        <div id="tn-tooltip-zoom-out" class="tn-tooltip tn-tooltip--top">Zoom Out</div>
      </div>
    </li>
    <li class="tn-syos-map-controls-list__list-item tn-syos-map-controls-list__list-item--zoom-in">
      <div id="tn-tooltip-container-zoom-in" class="tn-tooltip__container">
        <button type="button" class="btn btn-default tn-syos-zoom-control__btn tn-syos-zoom-control__btn-zoom tn-syos-zoom-control__btn-zoom--zoom-in">
          ${SvgIcon.getHtml(IconSprites.Plus, 'tn-syos-zoom-control__icon-btn-zoom')}
        </button>
        <div id="tn-tooltip-zoom-in" class="tn-tooltip tn-tooltip--top">Zoom In</div>
      </div>
    </li>
    <li class="tn-syos-map-controls-list__list-item tn-syos-map-controls-list__list-item--reset-zoom">
      <div id="tn-tooltip-container-reset-zoom" class="tn-tooltip__container">
        <button type="button" class="btn btn-default tn-syos-zoom-control__btn tn-syos-zoom-control__btn-reset">
          ${SvgIcon.getHtml(IconSprites.RecordCircle, 'tn-syos-zoom-control__icon-btn-reset')}
        </button>
        <div id="tn-tooltip-reset-zoom" class="tn-tooltip tn-tooltip--top">Reset Zoom</div>
      </div>
    </li>
  </ul>
</div>`) as HTMLDivElement;

  ['#tn-tooltip-container-reset-zoom',
    '#tn-tooltip-container-zoom-in',
    '#tn-tooltip-container-zoom-out',
  ].forEach((id) => new Tooltip($el.querySelector(id)!));

  return {
    el: $el,
    btnZoomInEl: $el.querySelector('.tn-syos-zoom-control__btn-zoom--zoom-in')!,
    btnZoomOutEl: $el.querySelector('.tn-syos-zoom-control__btn-zoom--zoom-out')!,
    btnResetEl: $el.querySelector('.tn-syos-zoom-control__btn-reset')!,
  };
}

export default {
  build,
};
